<template>
  <div class="modal-body">
    <div class="header proj-t-card">
      <h4>
        Envio de {{ miscellaneousType }}
        <font-awesome-icon
          :icon="[
            'fas',
            miscellaneousType === 'Aniversariantes'
              ? 'birthday-cake'
              : 'handshake',
          ]"
          :class="
            miscellaneousType === 'Aniversariantes'
              ? 'text-c-red'
              : 'text-c-green'
          "
        />
      </h4>
      <h6 class="sub-title">
        Envie uma notificação de {{ miscellaneousType }} para os associados.
      </h6>
    </div>

    <!-- <div>
      <div v-if="dateError" class="alert alert-danger text-c-red">
        <p>O vencimento final não pode ser anterior ao vencimento inicial.</p>
      </div>
      <div class="date-container">
        <div class="col-md-6">
          <label for="start-date">Vencimento Início</label>
          <vuejs-datepicker
            v-model="date1"
            :format="datepickerFormat"
            @change="validateDates"
          ></vuejs-datepicker>
        </div>
      </div>
    </div> -->

    <!-- TIPO DE ENVIO -->
    <div class="express-statuses">
      <label for="shipping-type">Tipo de Envio:</label>
      <select
        id="shipping-type"
        v-model="selectedShippingType"
        @change="shippingTypeChange"
      >
        <option disabled value="">Selecione...</option>
        <option v-for="(k, index) in shippingType" :key="index" :value="k">
          {{ k.title }}
        </option>
      </select>
    </div>
    <div
      v-if="selectedShippingType.title === 'Automatico'"
      class="express-statuses"
    >
      <label for="shipping-hour">Hora de Envio:</label>
      <vue-timepicker id="shipping-hour" v-model="timePicker" />
    </div>

    <Loading
      v-if="showModal"
      :is-loading="isLoading"
      :status="status"
      :message="modalMessage"
      @close="showModal = false"
    />
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-dark btn-danger"
        @click="clearShippingModal"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-outline-dark btn-info"
        :class="dateError && 'disabled'"
        @click="sendData"
      >
        Enviar
      </button>
    </div>
  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';

import Loading from '../../../../components/Loading.vue';

export default {
  components: {
    VueTimepicker,
    Loading,
  },
  props: {
    userMessage: {
      type: Array,
      require: true,
      default: [],
    },
    userData: {
      type: Object,
      require: true,
      default: {},
    },
    miscellaneousType: {
      type: String,
      require: true,
      default: 'Aniversariantes',
    },
    closeModal: {},
  },
  data() {
    return {
      date1: this.getCurrentDate(),
      timePicker: this.getCurrentDate(),
      datepickerFormat: 'DD/MM/YYYY',
      dateError: false,
      selectedShippingType: {},
      selectedUserMessage: {},
      isLoading: false,
      status: '',
      showModal: false,
      modalMessage: '',
      shippingType: [{ title: 'Manual' }, { title: 'Automatico' }],
    };
  },
  watch: {
    miscellaneousType() {
      this.date1 = this.getCurrentDate();
      this.datepickerFormat = 'DD/MM/YYYY';
      this.dateError = false;
      this.selectedUserMessage = {};
      this.isLoading = false;
      this.status = '';
      this.showModal = false;
      this.modalMessage = '';
    },
  },
  methods: {
    clearShippingModal() {
      this.date1 = this.getCurrentDate();
      this.date2 = this.getCurrentDate();
      this.dateError = false;

      this.selectedUserMessage = {};
      this.isLoading = false;
      this.status = '';
      this.showModal = false;
      this.modalMessage = '';
      this.closeModal();
    },
    async sendData() {
      this.showModal = true;
      this.isLoading = true;
      this.status = '';
    },
    getCurrentDate() {
      const today = new Date();

      return {
        HH: today.toLocaleTimeString('pt-BR', {
          hour: '2-digit',
          hour12: false,
        }),
        mm: today.getMinutes().toString(),
      };
    },

    userMessageChange() {
      return this.selectedExpressBilletSituation;
    },
    shippingTypeChange() {
      return this.selectedShippingType;
    },
  },
};
</script>

<style scoped>
.modal-body {
  padding: 20px;
}

.header {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  align-items: baseline;
}

.sub-title {
  margin-bottom: 0;
  font-size: 14px;
  color: #555;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}
.alert {
  padding: 10px;
  border: 2px solid red;
}
.datepicker {
  width: 100%;
  padding: 8px;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.date-container {
  display: flex;
  gap: 20px;
  padding: 20px;
}

.express-statuses {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 5px 0;
}
.btn {
  border-radius: 2px;
  text-transform: capitalize;
  font-size: 15px;
  padding: 0.625rem 1.1875rem;
  cursor: pointer;
  border: transparent;
}
.btn-info {
  background-color: #00bcd4;
  border-color: #00bcd4;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}
.btn-info:hover {
  background-color: #08e3ff;
  border-color: #08e3ff;
}
.btn-info:active {
  background-color: #008697;
  border-color: #008697;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}
.btn-info:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #08e3ff;
}
.btn-info.disabled {
  background-color: rgba(0, 188, 212, 0.5);
  border-color: rgba(0, 188, 212, 0.5);
}

.btn-danger {
  background-color: #ff5370;
  border-color: #ff5370;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-danger:hover {
  background-color: #ff869a;
  border-color: #ff869a;
}

.btn-danger:active {
  background-color: #ff163d;
  border-color: #ff163d;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-danger:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #ff869a;
}

.btn-danger.disabled {
  background-color: rgba(255, 83, 112, 0.5);
  border-color: rgba(255, 83, 112, 0.5);
}

.btn-success {
  background-color: #2ed8b6;
  border-color: #2ed8b6;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-success:hover {
  background-color: #59e0c5;
  border-color: #59e0c5;
}

.btn-success:active {
  background-color: #20a98e;
  border-color: #20a98e;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-success:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #59e0c5;
}

.btn-success.disabled {
  background-color: rgba(46, 216, 182, 0.5);
  border-color: rgba(46, 216, 182, 0.5);
}

.bg-c-red {
  background: #ff5370;
}
.text-c-red {
  color: #ff5370;
}
.bg-c-green {
  background: #2ed8b6;
}
.text-c-green {
  color: #2ed8b6;
}
.bg-c-yellow {
  background: #ffb64d;
}
.text-c-yellow {
  color: #ffb64d;
}
.m-b-5 {
  margin-bottom: 5px;
}
.m-b-0 {
  margin-bottom: 0;
}
.modal-footer {
  border: 2px solid blue;
  display: flex;
  gap: 10px;
}
</style>
